export default "__VITE_ASSET__CxklMhSg__"